// removed by extract-text-webpack-plugin
module.exports = {"empty":"_-src-components-Empty-index---empty---vXxr9","title":"_-src-components-Empty-index---title---3nxdB","description":"_-src-components-Empty-index---description---OZaxJ","actions":"_-src-components-Empty-index---actions---2iwKR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Empty/index.css
// module id = 649
// module chunks = 1